import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaFileInvoiceDollar, FaHotel, FaLayerGroup, FaList, FaPen, FaPlus, FaSearch, FaUserTie } from 'react-icons/fa';
import ErpTemplate from '../../components/ErpTemplate';
import CalendarioFreelancers from '../../components/CalendarioFreelancers';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelFreelancer() {
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem('perfil');
    const acessoSomenteFornecedores = ['suplier', 'backofficeinterno'].includes(perfil);
    const acessoSomenteFreelancers = ['backofficeinterno'].includes(perfil);
    const [abaAtiva, setAbaAtiva] = useState('lista');
    const [filtro, setFiltro] = useState({
        nome: '',
        email: '',
        cpf: '',
        buscando: false,
    });
    const [freelancers, setFreelancers] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setFiltro((state) => ({ ...state, buscando: true }));
        api({
            method: 'get',
            action: '/participante',
            token,
            params: {
                ...filtro,
                tipoCadastro: ['freelancer', 'pessoa'],
                // relações que esta tela lê (o endpoint só carrega o que for declarado)
                include: 'enderecomunicipio,evento,cargo',
                orderBy: {
                    tipoCadastro: 'asc',
                }
            },
            signal: controllerRef.current.signal
        })
            .then((response) => {
                setFreelancers(response.data.data ?? []);
                setPage(1);
                setFiltro((state) => ({ ...state, buscando: false }));
            })
            .catch((err) => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setFiltro((state) => ({ ...state, buscando: false }));
            });
    };

    useEffect(() => {
        document.querySelector('#nome')?.focus();
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
        // eslint-disable-next-line
    }, []);

    const paginados = useMemo(() => {
        const inicio = (page - 1) * pageSize;
        return freelancers.slice(inicio, inicio + pageSize);
    }, [freelancers, page, pageSize]);

    const totalPaginas = Math.max(1, Math.ceil(freelancers.length / pageSize));

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Freelancers</h1>
                        <p className="fin-pp__subtitle">Lista e calendário de contratações integrados ao hub de fornecedores.</p>
                    </div>
                    <div className="fin-pp__actions">
                        {!['evento'].includes(perfil) && (
                            <Link to="/cadastroFreelancer" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                                <FaPlus size={14} /> Novo Freelancer
                            </Link>
                        )}
                        {!acessoSomenteFreelancers && (
                            <Link to="/fornecedor" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaUserTie size={14} /> Fornecedores
                            </Link>
                        )}
                        {!acessoSomenteFornecedores && (
                            <Link to="/hotel" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaHotel size={14} /> Hotéis
                            </Link>
                        )}
                        {!acessoSomenteFornecedores && (
                            <Link to="/fornecedorGrupo" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaLayerGroup size={14} /> Grupos
                            </Link>
                        )}
                        {!acessoSomenteFornecedores && (
                            <Link to="/participanteCategoria" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaList size={14} /> Categorias
                            </Link>
                        )}
                        {!acessoSomenteFornecedores && (
                            <Link to="/compra" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaFileInvoiceDollar size={14} /> Faturas
                            </Link>
                        )}
                    </div>
                </div>

                <div className="fin-pp__tabs mb-3">
                    {[
                        { key: 'lista', label: 'Freelancers' },
                        { key: 'ocupacoes', label: 'Contratações' },
                    ].map((item) => (
                        <button
                            key={item.key}
                            type="button"
                            className={'fin-pp__tab' + (abaAtiva === item.key ? ' is-active' : '')}
                            onClick={() => setAbaAtiva(item.key)}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>

                {abaAtiva === 'lista' ? (
                    <>
                        <form
                            className="fin-pp__card"
                            style={{ padding: '12px 16px', marginBottom: 16 }}
                            onSubmit={(e) => { buscar(); e.preventDefault(); }}
                        >
                            <div className="fin-pp__filters">
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label" htmlFor="nome">Nome</label>
                                    <input
                                        id="nome"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        type="text"
                                        placeholder="Buscar pelo nome"
                                        value={filtro.nome ?? ''}
                                        onChange={(e) => setFiltro({ ...filtro, nome: e.target.value })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label" htmlFor="email">E-mail</label>
                                    <input
                                        id="email"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        type="text"
                                        placeholder="Buscar pelo e-mail"
                                        value={filtro.email ?? ''}
                                        onChange={(e) => setFiltro({ ...filtro, email: e.target.value })}
                                    />
                                </div>
                                <div className="fin-pp__field">
                                    <label className="fin-pp__label" htmlFor="cpf">CPF</label>
                                    <input
                                        id="cpf"
                                        className="fin-pp__input"
                                        style={{ paddingLeft: 14 }}
                                        type="text"
                                        placeholder="Buscar pelo CPF"
                                        value={filtro.cpf ?? ''}
                                        onChange={(e) => setFiltro({ ...filtro, cpf: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
                                <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={filtro.buscando}>
                                    <FaSearch size={14} /> {filtro.buscando ? 'Buscando...' : 'Buscar'}
                                </button>
                            </div>
                        </form>

                        <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                            <div className="fin-pp__tblwrap">
                                <table className="fin-pp__tbl" style={{ minWidth: 1100, tableLayout: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 62 }}></th>
                                            <th style={{ width: 110 }}>Tipo</th>
                                            <th style={{ width: 90 }}>Situação</th>
                                            <th style={{ width: 90 }}>Código</th>
                                            <th>Nome</th>
                                            <th>Cargo</th>
                                            <th>Município</th>
                                            <th>CPF/CNPJ</th>
                                            <th>E-mail</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filtro.buscando ? (
                                            <tr><td colSpan={9} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                        ) : paginados.length === 0 ? (
                                            <tr><td colSpan={9} className="fin-pp__empty">Nenhum registro</td></tr>
                                        ) : paginados.map((row) => (
                                            <tr key={row.id}>
                                                <td>
                                                    {!['evento'].includes(perfil) ? (
                                                        <Link to={`/cadastroFreelancer/${row.id}`} className="fin-pp__rowbtn" title="Alterar freelancer">
                                                            <FaPen size={14} />
                                                        </Link>
                                                    ) : null}
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.tipoCadastro === 'pessoa' ? 'Usuário' : 'Freelancer'}</td>
                                                <td>
                                                    <span className={`fin-pp__pill ${row.situacaoRegistro === 'inativo' ? 'is-muted' : 'is-ok'}`}>
                                                        {row.situacaoRegistro ?? 'ativo'}
                                                    </span>
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.codigo ?? ''}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ''}</td>
                                                <td className="fin-pp__cell-muted">{row.cargo?.nome ?? ''}</td>
                                                <td className="fin-pp__cell-muted">{row.enderecomunicipio ? `${row.enderecomunicipio.nome}-${row.enderecomunicipio.uf}` : ''}</td>
                                                <td className="fin-pp__cell-muted">{row.cpf || row.cnpj || ''}</td>
                                                <td className="fin-pp__cell-muted">{row.email ?? ''}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="fin-pp__pagination">
                                <div className="fin-pp__pagination-info">{freelancers.length} registros</div>
                                <div className="fin-pp__pagination-ctrls">
                                    <select
                                        className="fin-pp__select"
                                        style={{ height: 34 }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                        }}
                                    >
                                        <option value={15}>15 / pág</option>
                                        <option value={30}>30 / pág</option>
                                        <option value={50}>50 / pág</option>
                                    </select>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage((state) => state - 1)}>
                                        Anterior
                                    </button>
                                    <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage((state) => state + 1)}>
                                        Próxima
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <CalendarioFreelancers />
                )}
            </div>
        </ErpTemplate>
    );
}
